import { Component, inject } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { LocaleService, SettingsService } from '@placeos/common';
import { CustomTooltipData } from './custom-tooltip.component';
import { IconComponent } from './icon.component';
import { TranslatePipe } from './translate.pipe';

@Component({
    selector: 'language-select',
    template: `
        <div
            class="bg-base-100 relative -top-12 -right-1 flex max-h-[65vh] w-74 flex-col overflow-auto rounded-sm pb-3 shadow-sm"
            (click)="close()"
        >
            <div
                matRipple
                class="border-base-300 flex items-center space-x-2 border-b px-2 py-3"
            >
                <icon class="text-2xl">arrow_back</icon>
                <div class="">{{ 'COMMON.LANGUAGE' | translate }}</div>
            </div>
            <div class="px-4 py-2 text-xs opacity-60">
                {{ 'COMMON.LANGUAGE_SELECT' | translate }}
            </div>
            @for (lang of locales; track lang.id) {
                <button
                    matRipple
                    (click)="setLocale(lang.id)"
                    class="flex h-14 items-center justify-between space-x-8 px-2 text-left"
                >
                    <div
                        class="hover:bg-base-200 flex flex-1 items-center justify-between rounded-sm p-2 leading-tight"
                        [class.mt-2]="(lang.name | translate) !== lang.local"
                        [class.border]="active_locale === lang.id"
                        [class.border-info]="active_locale === lang.id"
                    >
                        <div>{{ lang.name | translate }}</div>
                        @if ((lang.name | translate) !== lang.local) {
                            <div
                                class="bg-base-300 rounded-sm px-2 py-1 text-xs opacity-60"
                            >
                                {{ lang.local }}
                            </div>
                        }
                    </div>
                    <!-- <div class="text-3xl">{{ lang.flag }}</div> -->
                </button>
            }
        </div>
    `,
    styles: [``],
    imports: [TranslatePipe, MatRippleModule, IconComponent],
})
export class LanguageSelectComponent {
    private _data = inject(CustomTooltipData);
    private _settings = inject(SettingsService);
    private _locale = inject(LocaleService);

    public readonly setLocale = (code: string) => {
        this._locale.setLocale(code);
        localStorage.setItem('PLACEOS.locale', code);
        setTimeout(() => location.reload(), 300);
    };

    public get active_locale() {
        return this._locale.locale;
    }

    public get locales(): { id: string; name: string; local?: string }[] {
        return this._settings.get('app.locales') || [];
    }

    public readonly close = () => this._data?.close();
}
